var PublicationService = /** @class */ (function () {
    function PublicationService(api) {
        var _this = this;
        this.createPublication = function (appId, publication, platform) {
            var url = "/publications/".concat(appId, "/").concat(platform, "/publish");
            if (platform === 'android') {
                return _this.API.postFormData(url, publication);
            }
            return _this.API.post(url, publication);
        };
        this.savePublication = function (appId, publicationId, publication, platform) {
            var url = "/publications/".concat(appId, "/").concat(platform, "/").concat(publicationId);
            if (platform === 'android') {
                return _this.API.patchFormData(url, publication);
            }
            return _this.API.patch(url, publication);
        };
        this.API = api;
    }
    PublicationService.prototype.publicationsList = function (appId, platform) {
        var url = "/publications/".concat(appId, "/").concat(platform);
        return this.API.get(url);
    };
    PublicationService.prototype.getPublication = function (appId, publicationId, platform) {
        var url = "/publications/".concat(appId, "/").concat(platform, "/").concat(publicationId);
        return this.API.get(url);
    };
    PublicationService.prototype.getPublicationWebLatest = function (appId) {
        var url = "/publications/".concat(appId, "/web/latest");
        return this.API.get(url);
    };
    PublicationService.prototype.createSubdomainAndPublish = function (appId, platform, publication, subdomain) {
        var url = "/publications/".concat(appId, "/").concat(platform, "/publish");
        return this.API.post(url, { publication: publication, subdomain: { name: subdomain } });
    };
    return PublicationService;
}());
export { PublicationService };
